import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StoreClassification } from 'app/models/classification.model';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';
import { CalendarGroupStoreList } from '../../models/calendar-group.model';
import { ListMetadata } from '../../models/list-metadata.model';
import { Card } from '../../models/loyalty-card.model';
import { ServiceStoreList } from '../../models/service.model';
import { StoreGroup, StoreModel, StoreSummaryModel, UserStoreDivision } from '../../models/store-common.model';
import { User } from '../../models/user.model';
import { HttpClientService } from '../httpClient/httpclient.service';
import { UsersService } from '../user/users.service';

@Injectable()
export class StoreCommonService {

  list_store: StoreSummaryModel[];
  list_filtered_groups: StoreSummaryModel[];
  editing: StoreModel;
  list_store_groups: StoreGroup[];
  list_user_store_divisions: UserStoreDivision[];
  editing_store_group: StoreGroup;
  editing_store_group_detail: any;
  editing_user_store_division: UserStoreDivision;

  private cachedFields: Observable<any>;
  private cachedUserStoreDivisionFields: Observable<any>;
  private cachedStoreGroupFields: Observable<any>;
  private cachedStoreGroupDetailFields: Observable<any>;

  private baseUrl = HttpClientService.BASE_MS_COMMON;
  private storesByChannel: any[]= [];

  constructor (
    private h: HttpClientService,
    private datePipe: DatePipe,
    private svcUsers: UsersService ) {
  }

  formatStore(store: StoreModel): any {
    let store_formatted: any = {};
    Object.assign(store_formatted, store);
    store_formatted['date_start'] = this.datePipe.transform(store_formatted['date_start'], 'yyyy-MM-dd');
    store_formatted['date_end'] = this.datePipe.transform(store_formatted['date_end'], 'yyyy-MM-dd');
    store_formatted['flg_graphical_printer'] = (!store_formatted['flg_graphical_printer'] || store_formatted['flg_graphical_printer'] == null) ? '0' : '1';
    store_formatted['flg_campaign_candidate'] = (!store_formatted['flg_campaign_candidate'] || store_formatted['flg_campaign_candidate'] == null) ? '0' : '1';
    return store_formatted;
  }

  parseStore(store: any): StoreModel {
    let store_preparse: any = {};
    Object.assign(store_preparse, store);
    store_preparse['flg_graphical_printer'] = store_preparse['flg_graphical_printer'] !== '0';
    store_preparse['flg_campaign_candidate'] = store_preparse['flg_campaign_candidate'] !== '0';
    store_preparse['date_start'] = new Date(store_preparse['date_start']);
    store_preparse['date_end'] = new Date(store_preparse['date_end']);
    return store_preparse;
  }

  /**
   * Kontable Capable Listing
   * @param offset
   * @param limit
   * @param search
   * @param globalSearch
   * @param sort
   * @param sort_dir
   */
  list (
    offset = null,
    limit = null,
    search?: Array<{ key: string, value: string }>,
    globalSearch?: string,
    sort?: string,
    sort_dir?: number
  ): Observable<{ data: Array<Card>, metadata: ListMetadata }> {
    const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
    return this.h.getPaged(this.baseUrl + '/store' + (params.toString() ? '?' + params.toString() : '' ));
  }

  getList(offset?, limit?, searchParams?) {
    let params: HttpParams = new HttpParams();

    if (offset) {
      params = params.set('offset', offset);
    }
    if (limit) {
      params = params.set('limit', limit);
    }
    if (searchParams) {
      for (const k in searchParams) {
        params = params.set(k, searchParams[k])
      }
    }

    return this.h.get(this.baseUrl + '/store' + (params.toString() ? '?' + params.toString() : ''))
      .map(res => {
        return this.list_store = res;
    })
  }
  getAllStores(limit?: number) {
    return this.h.get(this.baseUrl + '/store/all' + (limit ? ("?limit="+limit.toString()) : ""));
  }  

  getStoreByName(store?: string) {
    return this.h.get(this.baseUrl + '/store?codename=' + store).map(res => res.map(r => ({label: `${r.code} - ${r.name}`, value: `${r.id}`})))
  }

  getStoreByNameNew(store?: string) {
    return this.h.get(this.baseUrl + '/store?codename=' + store)
  }

  getStoreByStore(search?: Array<{ key: string, value: string }>) {
    const params = HttpClientService.buildListParams(null, null, search, null, null, null);
    return this.h.get(`${this.baseUrl}/store${params.toString() ? '?' + params.toString() : ''}`)
  }

  getStoreByStoreDetails(search?: Array<{ key: string, value: string }>) {
    const params = HttpClientService.buildListParams(null, null, search, null, null, null);
    return this.h.get(`${this.baseUrl}/store${params.toString() ? '?' + params.toString() : ''}`)
  }

  getStoreId(store?: string) {
    return this.h.get(this.baseUrl + '/store?store=' + store).map(res => res.map(r => r.id))
  }

  getListFilteredByChannel(channelId: number) : Observable<StoreModel[]> {
    return this.h.get(`${this.baseUrl}/store?channel=${channelId}`)
  }

  /**
   * Come getListFilteredByChannel, ma li restituisce in forma di oggetto composto da label (code + name) e value (id)
   * @param channelId
   */
  getStoresFilteredByChannel(channelId: number) {
    return this.h.get(`${this.baseUrl}/store?channel=${channelId}`).map(res => res.map(r => ({label: `${r.code} - ${r.name}`, value: `${r.id}`})))
  }

  getStoresByChannel(searchedStore: string, storeFrom: {label: string, value: number}): Promise<any[]> {
    this.storesByChannel = [];
    return new Promise(resolvePromise => {
      this.get(storeFrom.value).subscribe(
        store => {
          this.getStoresFilteredByChannel(store.channel_loyalty_id).subscribe(
            res => {
              res.filter(filteredStore =>
                filteredStore.label != storeFrom.label && filteredStore.label.toLowerCase().indexOf(searchedStore) != -1
              ).map(r => this.storesByChannel.push(r))
            },
            error => console.error(error),
            () => resolvePromise(this.storesByChannel)
          )
        }
      )
    })
  }

  getListUserStoreDivision() {
    return this.h.get(this.baseUrl + '/store/store_divisions')
      .map(res => {
        this.list_user_store_divisions = res;

        this.list_user_store_divisions.forEach(usd => {
          let u: User[]  = this.svcUsers.users.filter(usr => usr.id === usd.user_id);
          if (u != null && u.length > 0) {
            usd.username = u[0].surname + ' ' + u[0].name;
          } else {
            this.svcUsers.get(usd.user_id).subscribe(usr => {
              usd.username = usr.surname + ' ' + usr.name;
            })
          }
        });
        return this.list_user_store_divisions;
      })
  }

  getListFilteredByStoreGroup(store_group_id: number) {
    return this.h.get(this.baseUrl + '/store/by_store_group/' + store_group_id)
      .map(res => {
        return this.list_filtered_groups = res;
      })
  }

  get(id: number): Observable<StoreModel> {
    return this.h.get(this.baseUrl + `/store/${id}`)
      .map(res => {
        return this.parseStore(res);
      })
  }

  getStoreClassifications(storeId: number) {
    return this.h.get(this.baseUrl + '/store/' + storeId + '/classification');
  }

  putStoreClassification(storeId: number, data: StoreClassification[]) {
    return this.h.put(this.baseUrl + '/store/' + storeId + '/classification', data).map(res => {
      return res;
    });
  }

  post(store: StoreModel): Observable<StoreModel> {
    console.log('store', store);
    let store_formatted = this.formatStore(store);
    console.log('store_formatted', store_formatted);
    return this.h.post(this.baseUrl + '/store', store_formatted).map(res => {
      return res;
    })
  }

  postUserStoreDivision(usd: UserStoreDivision) {
    return this.h.post(this.baseUrl + '/store/store_divisions', usd);
  }

  put(id: number, store: StoreModel): Observable<StoreModel> {
    console.log('store', store);
    let store_formatted = this.formatStore(store);
    store_formatted['id'] = id;
    console.log('store_formatted', store_formatted);

    return this.h.put(this.baseUrl + '/store/' + id , store_formatted).map(res => {
      return res;
    })
  }

  putUserStoreDivision(id: number, usd: UserStoreDivision) {
    return this.h.put(this.baseUrl + '/store/store_divisions/' + id , usd);
  }

  delete (id: number) {
    return this.h.delete(this.baseUrl + '/store/' + id);
  }

  deleteUserStoreDivisions (id: number) {
    return this.h.delete(this.baseUrl + '/store/store_divisions/' + id);
  }

  recoverUserStoreDivisions (id: number) {
    return this.h.put(`${this.baseUrl}/store/store_divisions/recover/${id}`, null);
  }

  postToGroup(store_id: number, store_group_id: number) {
    return this.h.post(this.baseUrl + '/store/' + store_id + '/add_to_group/' + store_group_id, null);
  }

  deleteFromGroup(store_id: number, store_group_id: number) {
    return this.h.delete(this.baseUrl + '/store/' + store_id + '/delete_from_group/' + store_group_id);
  }

  search_from_campaign(params): Observable<any> {
    return this.h.post(this.baseUrl + '/store/search_from_campaign', params);
  }

  getServiceList(store_id: string): Observable<ServiceStoreList[]> {
    return this.h.get(this.baseUrl + /store/ + store_id + '/services');
  }

  getCalendarGroupList(store_id: string): Observable<CalendarGroupStoreList[]> {
    return this.h.get(this.baseUrl + /store/ + store_id + '/calendars');
  }

  getGroupList() {
    return this.h.get(this.baseUrl + '/store-group')
      .map(res => {
        return this.list_store_groups = res;
      })
  }

  getGroup(id: number) {
    return this.h.get(this.baseUrl + `/store-group/${id}`)
      .map(res => {
        return this.parseStore(res);
      });
  }

  postGroup(store_group: StoreGroup) {
    return this.h.post(this.baseUrl + '/store-group', store_group);
  }

  putGroup(id: number, store_group: StoreGroup) {
    store_group['id'] = id;

    return this.h.put(this.baseUrl + '/store-group/' + id , store_group);
  }

  deleteGroup (id: number) {
    return this.h.delete(this.baseUrl + '/store-group/' + id);
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get(this.baseUrl + '/schema/StoreDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

  getUserStoreDivisionFields() {
    if (!this.cachedUserStoreDivisionFields) {
      this.cachedUserStoreDivisionFields = this.h.get(this.baseUrl + '/schema/UserStoreDivisionDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedUserStoreDivisionFields;
  }

  getStoreGroupFields() {
    if (!this.cachedStoreGroupFields) {
      this.cachedStoreGroupFields = this.h.get(this.baseUrl + '/schema/StoreGroupDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedStoreGroupFields;
  }

  getStoreGroupDetailFields() {
    if (!this.cachedStoreGroupDetailFields) {
      this.cachedStoreGroupDetailFields = this.h.get(this.baseUrl + '/schema/StoreSummaryDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedStoreGroupDetailFields;
  }

  getUserStoresAndSalesNetworks(userId: string) {
    return this.h.get(`${this.baseUrl}/store/store_divisions/user/${userId}`);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/store/store-common.service.ts